import _ from 'lodash';
import { Action, Dispatch } from 'redux';
import { IAppState } from '../reducers';
import { getUsersByOrg } from '../../api/idm/api';
import { IUser } from '../../api/idm';

export interface IState {
  isOpen: boolean;
  isLoaded: boolean;
  users: IUser[];
}

export enum ActionType {
  Toggle = 'ActiveUsersDialog.Toggle',
  UpdatedLoaded = 'ActiveUsersDialog.UpdatedLoaded',
  Reset = 'ActiveUsersDialog.Reset',
  UpdateUsers = 'ActiveUsersDialog.UpdateUsers',
}

export interface IActiveUsersDialogAction extends Action<ActionType> {
  payload?: any;
}

const INITIAL_STATE: IState = {
  isOpen: false,
  isLoaded: false,
  users: [],
};

export default function reducer(state: IState = INITIAL_STATE, action: IActiveUsersDialogAction): IState {
  switch (action.type) {
    case ActionType.Toggle:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case ActionType.UpdatedLoaded:
      return {
        ...state,
        isLoaded: action.payload,
      };
    case ActionType.UpdateUsers:
      return {
        ...state,
        users: action.payload,
      };
    case ActionType.Reset:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
}

export const toggleActiveUsersDialog = () => (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const state = getState();
  if (!state.exchange.activeUsers.isOpen) {
    init()(dispatch, getState);
  }
  dispatch({
    type: ActionType.Toggle,
  });
};

export const reset = () => ({
  type: ActionType.Reset,
});

export const init = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const state = getState();
  if (state.exchange.activeUsers.isLoaded) {
    dispatch({
      type: ActionType.UpdatedLoaded,
      payload: false,
    });
  }
  const orgId = state.user.userOrgRole?.loginAs?.userOrgIds?.[0];
  if (orgId) {
    const activeUsers = (await getUsersByOrg(orgId)).data.data;
    dispatch({
      type: ActionType.UpdateUsers,
      payload: activeUsers,
    });
  }

  dispatch({
    type: ActionType.UpdatedLoaded,
    payload: true,
  });
};
